import { theme } from "styles/theme";

import { IInputButtonSize } from "uikit/types";

export const INPUT_FONT_SIZE: Record<IInputButtonSize, string> = {
  small: theme.size.t14,
  medium: theme.size.t14,
  large: theme.size.t14,
};

export const INPUT_LINE_HEIGHT: Record<IInputButtonSize, string> = {
  small: "140%",
  medium: "140%",
  large: "140%",
};

export const INPUT_PADDING: Record<IInputButtonSize, string> = {
  small: "8px 12px",
  medium: "12px",
  large: "12px",
};

export const INPUT_BORDER_RADIUS = "8px";
export const INPUT_FIXED_WIDTH_MAX = "360px";
